import React, { useState, useCallback, Children } from 'react';
import PropTypes from 'prop-types';
import { useClickOutside } from '@ers/hooks';
import cx from 'classnames';

const Drop = ({ trigger, children, openedOnInit, onClose, onOpen, align, className }) => {
    const [opened, setOpened] = useState(openedOnInit);
    const handleClick = useCallback(
        (e) => {
            e && e.preventDefault();
            if (opened) {
                onClose();
            } else {
                onOpen();
            }
            setOpened((prevOpened) => !prevOpened);
        },
        [opened],
    );
    const ref = useClickOutside(handleClick, opened);
    return (
        <div className={cx('drop', `drop--${align}`, className)} ref={ref}>
            {/* <div className="drop__trigger" onClick={handleClick}> */}
            {trigger('drop__trigger', handleClick)}
            {/* </div> */}
            {opened && (
                <div className="drop__children">
                    {Children.map(children, (child, i) => (<DropChild key={i}>{child}</DropChild>))}
                </div>
            )}
        </div>
    );
};

const DropChild = ({ children }) => (
    // <div className="drop__child">
    React.cloneElement(children, { className: 'drop__child' })
    // </div>
);



Drop.propTypes = {
    trigger: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
    openedOnInit: PropTypes.bool,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    align: PropTypes.oneOf(['left', 'center', 'right'])
};
Drop.defaultProps = {
    openedOnInit: false,
    onClose: () => null,
    onOpen: () => null,
    align: 'right'
};

export default Drop;
